var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[(!_vm.$route.fullPath.includes('login') )?_c('v-navbar'):_vm._e(),(!_vm.$route.fullPath.includes('login') )?_c('v-header'):_vm._e(),_c('v-loader'),_c('div',{staticClass:"page-block",class:{ 'full-page': _vm.$route.fullPath.includes('login')}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }